export const deleteQuizQuestion = (payload?: any) => ({
    type: "@saga/DELETE_QUIZ_QUESTION",
    payload
});

